import React from 'react'
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Generating metrics for Identity Verification'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Generating metrics' subtitle='Generating metrics for Identity Verification' mdxType="Header" />
    <p>{`You can view the status of any Identity Verification session in the Dashboard. To obtain aggregated data such as the percentage of sessions that were completed or the percentage that passed verification vs. were rejected, you will need to use the API to generate the data. `}</p>
    <h4 {...{
      "id": "conversion-and-success-rates"
    }}>{`Conversion and success rates`}</h4>
    <p>{`The `}<em parentName="p">{`conversion rate`}</em>{` is defined as the percentage of sessions begun that were completed, regardless of whether the user passed or failed verification.`}</p>
    <p>{`The `}<em parentName="p">{`success rate`}</em>{` is defined as the percentage of completed sessions that resulted in the user passing verification.`}</p>
    <h4 {...{
      "id": "calculating-success-rates"
    }}>{`Calculating success rates`}</h4>
    <p>{`The most comprehensive way to measure overall success rates is to use `}<inlineCode parentName="p">{`/identity_verification/get`}</inlineCode>{`, since it includes backend-only sessions, sessions generated using shareable links, and manual overrides after the session is completed.`}</p>
    <p>{`If the status is `}<inlineCode parentName="p">{`success`}</inlineCode>{`, the verification succeeded.`}</p>
    <p>{`If the status is `}<inlineCode parentName="p">{`failed`}</inlineCode>{` or `}<inlineCode parentName="p">{`pending_review`}</inlineCode>{`, the verification did not succeed.`}</p>
    <p>{`The success rate is the number of sessions with the `}<inlineCode parentName="p">{`success`}</inlineCode>{` status divided by the total of all sessions with the `}<inlineCode parentName="p">{`success`}</inlineCode>{`, `}<inlineCode parentName="p">{`failed`}</inlineCode>{`, or `}<inlineCode parentName="p">{`pending_review`}</inlineCode>{` status.`}</p>
    <p>{`Sessions with a status other than `}<inlineCode parentName="p">{`success`}</inlineCode>{`, `}<inlineCode parentName="p">{`failed`}</inlineCode>{`, or `}<inlineCode parentName="p">{`pending_review`}</inlineCode>{` should be discarded for the purpose of calculating overall success rates, since they represent sessions that were not completed.`}</p>
    <h4 {...{
      "id": "calculating-conversion-rates"
    }}>{`Calculating conversion rates`}</h4>
    <p>{`If you want to measure the conversion rate, you can use the `}<inlineCode parentName="p">{`onEvent`}</inlineCode>{` callback. A session is started if you receive the `}<inlineCode parentName="p">{`IDENTITY_VERIFICATION_START_STEP`}</inlineCode>{` event. It was completed if you receive either the `}<inlineCode parentName="p">{`IDENTITY_VERIFICATION_PASS_SESSION`}</inlineCode>{` or `}<inlineCode parentName="p">{`IDENTITY_VERIFICATION_FAIL_SESSION`}</inlineCode>{` event, and it was successful only if you receive the `}<inlineCode parentName="p">{`IDENTITY_VERIFICATION_PASS_SESSION`}</inlineCode>{`. To correlate different events with the same Link session, use the `}<inlineCode parentName="p">{`link_session_id`}</inlineCode>{`. For more details, see `}<a parentName="p" {...{
        "href": "/docs/identity-verification/link"
      }}>{`Link callbacks`}</a>{`.`}</p>
    <p>{`For Identity Verification, `}<inlineCode parentName="p">{`onEvent`}</inlineCode>{` callback information is not available via the `}<inlineCode parentName="p">{`/link/token/get`}</inlineCode>{` endpoint. `}</p>
    <p>{`Alternatively, you can calculate conversion using `}<inlineCode parentName="p">{`/identity_verification/get`}</inlineCode>{`. The conversion rate is the number of sessions with a status of `}<inlineCode parentName="p">{`success`}</inlineCode>{`, `}<inlineCode parentName="p">{`failed`}</inlineCode>{`, or `}<inlineCode parentName="p">{`pending_review`}</inlineCode>{` divided by the total number of unique identity verification IDs. Because this metric includes sessions where the result was manually overridden, as well as backend-only sessions, it will provide different results from Link-based conversion metrics, especially if you use a combination of backend-based sessions and Link-based sessions. Whether it makes more sense to report on overall conversion or Link-based conversion will depend on your use case. `}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "conversion-and-success-rates",
        level: 4,
        title: "Conversion and success rates",
      },
{
        id: "calculating-success-rates",
        level: 4,
        title: "Calculating success rates",
      },
{
        id: "calculating-conversion-rates",
        level: 4,
        title: "Calculating conversion rates",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
